export default "__VITE_ASSET__d24af558__"